import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
import { Form, Button, Header, Checkbox, Container, Icon, Message } from 'semantic-ui-react';
import _get from 'lodash/get';
import _isString from 'lodash/isString';
import { ContactFormFieldPropType } from './ContactForm.propTypes';
import { getFinalDestinationEmail } from './ContactForm.utils';
import ContactFormInput from './components/ContactFormInput';
import ReCaptchaForm from '../../components/RecaptchaForm';
import { ActionName } from '../../components/RecaptchaProvider/RecaptchaProvider.constants';
import { Event } from '../../modules/analytics/components';
import { EVENT_ACTIONS, EVENT_CATEGORIES } from '../../modules/analytics/components/Event';
import { EventPropType } from '../../modules/analytics/types';
import { GoogleAnalytics } from '../../services/analytics';
import { sendContactFormEmail } from '../../utils/api';
import { classNames } from '../../utils/classname';
import './ContactForm.css';
function createFieldGroups(fields) {
  return fields.reduce(function (acc, _, i) {
    return i % 2 ? acc : [].concat(_toConsumableArray(acc), [fields.slice(i, i + 2)]);
  }, []);
}
var ContactForm = /*#__PURE__*/function (_React$Component) {
  _inherits(ContactForm, _React$Component);
  var _super = _createSuper(ContactForm);
  function ContactForm(props) {
    var _this;
    _classCallCheck(this, ContactForm);
    _this = _super.call(this, props);
    _this.state = _this.createInitialState();
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.toggleOptIn = _this.toggleOptIn.bind(_assertThisInitialized(_this));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.clearInputs = _this.clearInputs.bind(_assertThisInitialized(_this));
    _this.setInlineMessage = _this.setInlineMessage.bind(_assertThisInitialized(_this));
    _this.inputShouldDisplayError = _this.inputShouldDisplayError.bind(_assertThisInitialized(_this));
    _this.initializeContactForm = _this.initializeContactForm.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ContactForm, [{
    key: "handleSubmit",
    value: function () {
      var _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, recaptchaToken) {
        var _this$props, onSubmit, onSubmitSuccess, onSubmitError, locationId, businessId, businessType, emailSubject, constructMessage, destinationEmails, destinationEmail, getDestinationEmail, successMessage, recaptchaAction, fields, email, name, contactOptIn, finalDestinationEmail;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props = this.props, onSubmit = _this$props.onSubmit, onSubmitSuccess = _this$props.onSubmitSuccess, onSubmitError = _this$props.onSubmitError, locationId = _this$props.locationId, businessId = _this$props.businessId, businessType = _this$props.businessType, emailSubject = _this$props.emailSubject, constructMessage = _this$props.constructMessage, destinationEmails = _this$props.destinationEmails, destinationEmail = _this$props.destinationEmail, getDestinationEmail = _this$props.getDestinationEmail, successMessage = _this$props.successMessage, recaptchaAction = _this$props.recaptchaAction;
              fields = this.state.fields;
              email = fields.email, name = fields.name, contactOptIn = fields.contact_opt_in;
              if (!this.areAllRequiredFieldsFilled()) {
                _context.next = 23;
                break;
              }
              finalDestinationEmail = getFinalDestinationEmail(destinationEmail, function () {
                return getDestinationEmail ? getDestinationEmail(fields) : null;
              });
              _context.prev = 5;
              this.setState({
                loading: true
              });
              _context.next = 9;
              return onSubmit({
                businessType: businessType,
                businessId: businessId,
                locationId: locationId,
                name: name,
                email: email,
                emailSubject: emailSubject,
                message: constructMessage(fields),
                contactOptIn: contactOptIn,
                recaptchaToken: recaptchaToken,
                destinationEmail: finalDestinationEmail,
                destinationEmails: destinationEmails,
                action: recaptchaAction
              });
            case 9:
              this.clearInputs();
              this.setInlineMessage(successMessage, 'green');
              if (onSubmitSuccess) {
                onSubmitSuccess();
              }
              _context.next = 18;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](5);
              if (onSubmitError) {
                onSubmitError();
              }
              this.setInlineMessage('Unknown error sending contact form. Please try again later.', 'red');
            case 18:
              _context.prev = 18;
              this.resetErrorState();
              return _context.finish(18);
            case 21:
              _context.next = 25;
              break;
            case 23:
              this.setInlineMessage('Please fill in all required fields!', 'red');
              this.setState({
                displayFieldErrors: true
              });
            case 25:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[5, 14, 18, 21]]);
      }));
      function handleSubmit(_x, _x2) {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }()
  }, {
    key: "onChange",
    value: function onChange(e, _ref) {
      var name = _ref.name,
        value = _ref.value;
      var _this$state = this.state,
        fields = _this$state.fields,
        touched = _this$state.touched;
      if (!touched) {
        this.triggerFillFormEvent();
      }
      this.setInlineMessage('');
      this.setState({
        displayFieldErrors: false,
        fields: _objectSpread(_objectSpread({}, fields), {}, _defineProperty({}, name, value)),
        touched: true
      });
    }
  }, {
    key: "setInlineMessage",
    value: function setInlineMessage(msg) {
      var _this2 = this;
      var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var messageTimeout = this.props.messageTimeout;
      this.setState({
        inlineMessage: msg,
        inlineMessageClass: className
      });
      if (className !== 'green' && msg !== '') {
        setTimeout(function () {
          return _this2.setState({
            inlineMessage: ''
          });
        }, messageTimeout);
      }
    }
  }, {
    key: "triggerFillFormEvent",
    value: function triggerFillFormEvent() {
      var event = this.props.event;
      var category = _get(event, 'category', EVENT_CATEGORIES.CONTACT_EVENT_CATEGORY);
      GoogleAnalytics.event({
        category: category,
        action: EVENT_ACTIONS.CONTACT_FILL_FORM_EVENT_ACTION
      });
    }
  }, {
    key: "toggleOptIn",
    value: function toggleOptIn() {
      var _this3 = this;
      this.setState(function (prevState) {
        var fields = prevState.fields,
          touched = prevState.touched;
        if (!touched) {
          _this3.triggerFillFormEvent();
        }
        return {
          displayFieldErrors: false,
          fields: _objectSpread(_objectSpread({}, fields), {}, {
            contact_opt_in: !fields.contact_opt_in
          }),
          touched: true
        };
      });
    }
  }, {
    key: "resetErrorState",
    value: function resetErrorState() {
      this.setState({
        displayFieldErrors: false,
        loading: false
      });
    }
  }, {
    key: "clearInputs",
    value: function clearInputs() {
      var fields = this.props.fields;
      var formFieldState = fields.reduce(function (acc, _ref2) {
        var label = _ref2.label;
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, label, ''));
      }, {});
      this.setState({
        fields: formFieldState,
        touched: false
      });
    }
  }, {
    key: "createInitialState",
    value: function createInitialState() {
      var _this$props2 = this.props,
        fields = _this$props2.fields,
        termsCopy = _this$props2.termsCopy;
      var formFieldState = fields.reduce(function (acc, _ref3) {
        var label = _ref3.label,
          value = _ref3.value;
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, label, value));
      }, {});
      var additionalState = {
        inlineMessageClass: '',
        inlineMessage: '',
        displayFieldErrors: false,
        loading: false,
        touched: false
      };
      var acceptTermsState = termsCopy ? {
        acceptedTerms: false
      } : {};
      return _objectSpread(_objectSpread({
        fields: _objectSpread({}, formFieldState)
      }, additionalState), acceptTermsState);
    }
  }, {
    key: "initializeContactForm",
    value: function initializeContactForm() {
      var initState = this.createInitialState();
      this.setState(initState);
    }
  }, {
    key: "areAllRequiredFieldsFilled",
    value: function areAllRequiredFieldsFilled() {
      var fields = this.state.fields;
      var fieldsProps = this.props.fields;
      return fieldsProps.filter(function (field) {
        return field.required && !fields[field.label];
      }).length === 0;
    }
  }, {
    key: "inputShouldDisplayError",
    value: function inputShouldDisplayError(field) {
      var _this$state2 = this.state,
        displayFieldErrors = _this$state2.displayFieldErrors,
        fields = _this$state2.fields;
      return field.required && displayFieldErrors && !fields[field.label];
    }
  }, {
    key: "mapFieldsToInputGroup",
    value: function mapFieldsToInputGroup(fields) {
      var _this4 = this;
      var showLabels = this.props.showLabels;
      var allFields = this.state.fields;
      return /*#__PURE__*/React.createElement(Form.Group, {
        widths: "equal",
        key: fields[0].label
      }, fields.map(function (field) {
        return /*#__PURE__*/React.createElement(ContactFormInput, {
          showLabels: showLabels,
          field: field,
          value: allFields[field.label],
          onChange: _this4.onChange,
          error: _this4.inputShouldDisplayError(field)
        });
      }));
    }
  }, {
    key: "renderForms",
    value: function renderForms() {
      var _this5 = this;
      var disabledInputs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _this$props3 = this.props,
        fields = _this$props3.fields,
        inline = _this$props3.inline,
        showLabels = _this$props3.showLabels,
        hideOptIn = _this$props3.hideOptIn;
      var allFields = this.state.fields;

      // Create chunks of two forms per group
      var fieldGroups = createFieldGroups(fields);

      // Wrap fields with form components
      var formGroups = fieldGroups.map(function (fieldGroup) {
        return _this5.mapFieldsToInputGroup(fieldGroup);
      });
      var forms = fields.map(function (field) {
        return /*#__PURE__*/React.createElement(ContactFormInput, {
          showLabels: showLabels,
          field: field,
          value: allFields[field.label],
          disabled: disabledInputs,
          onChange: _this5.onChange,
          error: _this5.inputShouldDisplayError(field)
        });
      });
      var fieldsWithForms = inline ? formGroups : forms;
      return /*#__PURE__*/React.createElement(React.Fragment, null, fieldsWithForms, !hideOptIn && /*#__PURE__*/React.createElement(Form.Field, {
        disabled: disabledInputs
      }, /*#__PURE__*/React.createElement(Checkbox, {
        id: "contact_opt_in",
        name: "contact_opt_in",
        label: /*#__PURE__*/React.createElement("label", {
          htmlFor: "contact_opt_in"
        }, "By entering your information, you permit us to reach out to you with future communications."),
        onChange: this.toggleOptIn,
        checked: allFields.contact_opt_in
      })));
    }
  }, {
    key: "renderTOS",
    value: function renderTOS() {
      var termsCopy = this.props.termsCopy;
      var acceptTerms = this.state.acceptTerms;
      return termsCopy && /*#__PURE__*/React.createElement(Form.Field, {
        control: Checkbox,
        label: termsCopy,
        value: acceptTerms,
        onChange: this.onChange
      });
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _this$props4 = this.props,
        header = _this$props4.header,
        subheader = _this$props4.subheader,
        centeredHeaders = _this$props4.centeredHeaders;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: classNames({
          'contact-form-header-container': true,
          centered: centeredHeaders
        })
      }, header && (_isString(header) ? /*#__PURE__*/React.createElement(Header, {
        as: "div",
        className: "h1"
      }, header) : header), subheader && (_isString(subheader) ? /*#__PURE__*/React.createElement(Header, {
        as: "div",
        className: "h3 subheader"
      }, subheader) : subheader)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        buttonText = _this$props5.buttonText,
        className = _this$props5.className,
        fluidButton = _this$props5.fluidButton,
        withContainer = _this$props5.withContainer,
        button = _this$props5.button,
        event = _this$props5.event,
        recaptchaAction = _this$props5.recaptchaAction,
        hideRecaptchaNotice = _this$props5.hideRecaptchaNotice;
      var _this$state3 = this.state,
        loading = _this$state3.loading,
        inlineMessage = _this$state3.inlineMessage,
        inlineMessageClass = _this$state3.inlineMessageClass;
      var isSuccessMsg = inlineMessageClass === 'green';
      var form = /*#__PURE__*/React.createElement("div", {
        className: "contact-form ".concat(className)
      }, /*#__PURE__*/React.createElement(ReCaptchaForm, {
        loading: loading,
        onSubmit: this.handleSubmit,
        success: isSuccessMsg,
        error: !isSuccessMsg,
        action: recaptchaAction,
        hideRecaptchaNotice: hideRecaptchaNotice
      }, this.renderHeader(), this.renderForms(isSuccessMsg), this.renderTOS(), /*#__PURE__*/React.createElement("div", null, inlineMessage && /*#__PURE__*/React.createElement(Message, {
        success: isSuccessMsg,
        negative: !isSuccessMsg
      }, /*#__PURE__*/React.createElement(Message.Content, null, inlineMessage, isSuccessMsg && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
        name: "check circle outline"
      })))), button && !isSuccessMsg && /*#__PURE__*/React.createElement(Event, {
        eventType: "click",
        event: event
      }, /*#__PURE__*/React.createElement(Button, {
        primary: true,
        fluid: fluidButton
      }, buttonText)), button && isSuccessMsg && /*#__PURE__*/React.createElement(Button, {
        onClick: this.initializeContactForm,
        primary: true,
        fluid: fluidButton
      }, "Send Another Message"))));
      return withContainer ? /*#__PURE__*/React.createElement(Container, null, form) : form;
    }
  }]);
  return ContactForm;
}(React.Component);
export { ContactForm as default };
ContactForm.defaultProps = {
  emailSubject: '',
  fields: [{
    label: 'name',
    placeholder: 'Name',
    type: 'input',
    required: true
  }, {
    label: 'email',
    placeholder: 'you@gmail.com',
    type: 'input',
    inputType: 'email',
    required: true
  }, {
    label: 'message',
    placeholder: 'Message',
    type: 'textarea',
    required: true
  }],
  constructMessage: function constructMessage(_ref4) {
    var message = _ref4.message;
    return message;
  },
  onSubmit: sendContactFormEmail,
  onSubmitSuccess: null,
  onSubmitError: null,
  messageTimeout: 10000,
  buttonText: 'Submit',
  centeredHeaders: false,
  className: '',
  fluidButton: false,
  button: true,
  header: '',
  inline: false,
  showLabels: false,
  subheader: '',
  termsCopy: '',
  withContainer: true,
  destinationEmail: '',
  destinationEmails: [],
  getDestinationEmail: function getDestinationEmail() {
    return null;
  },
  hideOptIn: false,
  successMessage: 'Successfully sent!',
  event: null,
  recaptchaAction: ActionName.SUBMIT_CONTACT_FORM,
  hideRecaptchaNotice: false
};